import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import PointExchangeAPI from "apiConfig/PointExchangeAPI";
import { Status } from "../../../../../redux/constant";

const initialState = {
  status: Status.INITIAL,
  errorMessage: null,
};

export const fetchAsyncUnlinkPartner = createAsyncThunk(
  "unlinkPartner/fetchAsyncUnlinkPartner",
  async ({ partnerId }, { rejectWithValue }) => {
    try {
      const response = await PointExchangeAPI.delete(
        `partners/${partnerId}/link`,
      );
      return response;
    } catch (err) {
      if (err.response) {
        return rejectWithValue({
          status: err.response.status,
          data: err.response.data,
        });
      }
      return rejectWithValue({
        status: "",
        data: err.message,
      });
    }
  },
);

const UnlinkPartnerSlice = createSlice({
  name: "unlinkPartner",
  initialState,
  reducers: {
    resetUnlinkPartner: state => {
      state.status = Status.INITIAL;
      state.errorMessage = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAsyncUnlinkPartner.pending, state => {
        state.errorMessage = null;
        state.status = Status.LOADING;
      })
      .addCase(fetchAsyncUnlinkPartner.fulfilled, (state, { payload }) => {
        state.status = Status.LOADED;
      })
      .addCase(fetchAsyncUnlinkPartner.rejected, (state, { payload }) => {
        if (payload === undefined) {
          state.status = Status.ERROR;
          return;
        }
        state.errorMessage = payload.data;
        state.status = Status.ERROR;
      });
  },
});

export const { resetUnlinkPartner } = UnlinkPartnerSlice.actions;

export default UnlinkPartnerSlice.reducer;
